module.exports = __webpack_public_path__ + "static/img/5234_phase_function_Paper_PointsHejduk_Prediction.e9a745b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5234_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 49uU
// module chunks = 0